import React, { useEffect, useState } from "react";
import { Branch } from "../types";
import axiosInstance from "api/AxiosInstance";
import { Link } from "react-router-dom";

const AboutUsBranches = () => {
  const [branchList, setBranchList] = useState<Branch[]>([]);
  const fetchData = async () => {
    const response = await axiosInstance
      .get("/Home/getBusinessLocation")
      .then((response) => {
        setBranchList(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="nc-AboutUsBranches flex flex-col sm:flex-row justify-center bg-zinc-700 text-white py-6">
      {branchList &&
        branchList.map((item, index) => (
          <div key={item.branchName} className="text-center py-4 sm:px-12">
            <h3 className="font-bold text-lg dark:text-neutral-200 mb-2">
              {item.fullBranchName}
            </h3>
            <span className={`block mt-1`}>{item.street1}</span>
            {item.street2 && <span className={``}>{item.street2}</span>}
            <span className={`block`}>
              {`${item.city}, ${item.province}, ${item.postalCode}`}
            </span>
            <span className={``}>{item.country}</span>
            {item.phoneNumber && (
              <div className={``}>
                p:{" "}
                <Link to={`tel:${item.phoneNumber}`}>{item.phoneNumber}</Link>
              </div>
            )}
            {item.email && (
              <div className={``}>
                e: <Link to={`mailto:${item.email}`}>{item.email}</Link>
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

export default AboutUsBranches;
